<template>
  <el-col :span="7" style="height: 100%">
    <div class="shop">
      <div class="head flex" style="text-align: center">
        <div style="color: #252c38; font-size: 16px;display: flex;align-items: center;">
          店铺信息
          <img
            v-if="subscribeType==1"
            src="../../assets/images/home/icon_标准版.png"
            alt
            style="margin: 0px 0px -4px 4px; position: relative"
          />
          <img v-else-if="subscribeType==2" src="../../assets/images/home/icon_高级版.png" alt />
          <img v-else src="../../assets/images/home/icon_美妆版.png" alt />
        </div>
        <el-dropdown>
          <div class="contact-servece">
            <i class="el-icon-service"></i> 联系客服
          </div>
          <el-dropdown-menu slot="dropdown">
            <div class="hoverInfo">
              <!-- <div class="top">
                      <img src="../../assets/newHomeIcon/top.png" alt />
              </div>-->
              <div class="info-line">热线电话：020-28970151</div>
              <div class="info-line">周末客服：18925068928</div>
              <div class="info-line">咚咚咨询：dd_1jm8pmp5oonqa</div>
              <div class="info-line">
                <span>QQ咨询：</span>
                <a
                  href="tencent://message/?uin=800152084&Site=在线客服&Menu=yes"
                  target="_blank"
                >
                  <span class="btn">客服1</span>
                </a>
                <a
                  href="tencent://message/?uin=800152084&Site=在线客服&Menu=yes"
                  target="_blank"
                >
                  <span class="btn">客服2</span>
                </a>
              </div>
              <div class="info-line">微信咨询：yunduanxin-yunqi</div>
              <div class="qrcode-box">
                <a
                  href="https://www.yuque.com/yunduanxincrm/bbl69v/whd1ng"
                  style="text-decoration: none"
                  target="_blank"
                >
                  <div class="code-item" style="margin-top: 10px">
                    <img src="../../assets/images/header_code4.jpg" />
                    <div class="text1">帮助文档</div>
                  </div>
                </a>
                <a
                  href="https://www.yuque.com/yunduanxincrm/bbl69v/rq55fh"
                  style="text-decoration: none"
                  target="_blank"
                >
                  <div class="code-item">
                    <img src="../../assets/images/header_code2.png" />
                    <div class="text">智能问答</div>
                  </div>
                </a>
              </div>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="shop-content">
        <div class="my-info-box">
          <div class="myInfo">
            <div class="header-img">
              <img class="header" :src="picImg" alt />
            </div>
            <div>
              <!-- <div class="shop-title">店铺名称</div>
              <div class="shop-name" v-if="this.$store.getters.loginUserInfo">
                {{ this.$store.getters.loginUserInfo.shopTitle }}
              </div> -->
              <!-- <el-button class="pop-btn">POP版</el-button> -->
            </div>
          </div>
          <div class="version-icon">
            <span>店铺名称</span>
            <div class="shop-name" v-if="this.$store.getters.loginUserInfo">
              {{ this.$store.getters.loginUserInfo.shopTitle }}
            </div>
          </div>
        </div>
        <div class="details">
          <div class="top">
            <span class="txt">短信（条）</span>
            <div class="rightBtn">
              <span class="autograph">{{
                this.$store.getters.loginUserInfo.paySmsTotal -
                  this.$store.getters.loginUserInfo.useSmsTotal || "--"
              }}</span>
              <button
                v-zoom="{'name':'短信充值','from':'首页'}" 
                class="recharge" @click="goRecharge">充值</button>
            </div>
          </div>
          <div class="bottom">
            <div class="left_content">
              <span class="txt">软件有效期/天</span>
              <span class="num">{{ daysSoft }}</span>
            </div>
            <div class="rightBtn">
              <button class="renew" v-zoom="{'name':'软件续费','from':'首页'}"  @click="goRenew">续费</button>
              <span class="time">有效期至：{{ invalidateDate || "--" }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-col>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    // 订购类型
    subscribeType(){
      return this.$store.getters.loginUserInfo.subscribeType;
    },

    picImg() {
      var defaultImg = require("@/assets/images/home/header.png");

      var img = defaultImg;
      if (
        this.$store.getters.loginUserInfo &&
        this.$store.getters.loginUserInfo.picPath
      ) {
        img = this.$store.getters.loginUserInfo.picPath;
      }
      return img;
    },
    invalidateDate() {
      var invalidateDate = this.$store.getters.loginUserInfo.invalidateDate;
      if (invalidateDate) {
        invalidateDate = invalidateDate.substr(0, 10);
      }
      return invalidateDate;
    },
    daysSoft() {
      var str = "--";
      var invalidateDate = this.invalidateDate;
      if (invalidateDate) {
        str = this.daysBetween(invalidateDate, this.getTodayYMD()) - 1;
      }
      return str;
    },
  },
  mounted() {},
  methods: {
    // 跳转续费链接
    goRenew() {
      var url = "https://fw.jd.com/main/detail/FW_GOODS-1631?rdct=true";
      window.open(url, "_blank");
    },

    // 跳转充值页面
    goRecharge() {
      let routeUrl = this.$router.resolve({
        path: "/backstage/backstage/sms_management",
      });
      window.open(routeUrl.href, "_blank");
    },

    // 求两个时间的天数差 日期格式为 YYYY-MM-dd
    daysBetween(DateOne, DateTwo) {
      var OneMonth = DateOne.substring(5, DateOne.lastIndexOf("-"));
      var OneDay = DateOne.substring(
        DateOne.length,
        DateOne.lastIndexOf("-") + 1
      );
      var OneYear = DateOne.substring(0, DateOne.indexOf("-"));

      var TwoMonth = DateTwo.substring(5, DateTwo.lastIndexOf("-"));
      var TwoDay = DateTwo.substring(
        DateTwo.length,
        DateTwo.lastIndexOf("-") + 1
      );
      var TwoYear = DateTwo.substring(0, DateTwo.indexOf("-"));

      var cha =
        (Date.parse(OneMonth + "/" + OneDay + "/" + OneYear) -
          Date.parse(TwoMonth + "/" + TwoDay + "/" + TwoYear)) /
        86400000;
      return Math.abs(cha);
    },

    // 获取当前时间. 格式为：年-月-日
    getTodayYMD() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var month = month < 10 ? "0" + month : month;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var ymdStr = year + "-" + month + "-" + day;
      return ymdStr;
    },
  },
};
</script>

<style scoped lang="scss">
/** 联系客户弹窗  */
.hoverInfo {
  // position: absolute;
  width: 271px;
  // height: 341px;
  // border: 1px solid #EEEEEE;
  // box-shadow: 0px 10px 16px rgba(51, 51, 51, 0.16);
  // border-radius: 5px;
  // background: #fff;
  right: 0;
  top: 30px;
  z-index: 9;
  font-size: 13px;
  color: #666;
  padding: 20px 20px 0 20px;
  .info-line {
    margin-bottom: 12px;
    line-height: 18px;
    .btn {
      width: 58px;
      height: 18px;
      display: inline-block;
      background: #4878ff;
      color: #fff;
      text-align: center;
      margin-right: 8px;
      border-radius: 2px;
      font-size: 11px;
      cursor: pointer;
    }
  }
  .qrcode-box {
    a {
      display: inline-block;
    }
    .code-item {
      display: inline-block;
      width: 100px;
      &:first-child {
        margin-right: 14px;
      }
      .img {
        width: 103px;
        height: 103px;
      }
      .text1 {
        border-top: 1px solid #f0f0f0;
        margin-top: 10px;
        margin-right: -11px;
        padding: 10px 18px;
        text-align: center;
        font-size: 14px;
        color: #999;
        border-right: 1px solid #f0f0f0;
        // &:hover{
        //   color: #fe4d45;
        // }
      }
      .text {
        border-top: 1px solid #f0f0f0;
        margin-top: 10px;
        padding: 10px 18px;
        text-align: center;
        font-size: 14px;
        color: #999;
        //  &:hover{
        //   color: #fe4d45;
        // }
      }
    }
  }
  // .top {
  //   display: flex;
  //   justify-content: center;
  //   position: absolute;
  //   top: -14px;
  //   right: 25px;
  //   img {
  //     width: 20px;
  //     height: 20px;
  //   }
  // }
}

.flex {
  display: flex;
  align-items: center;
  // align-content:center ;
}
.contact-servece {
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  padding: 0 12px;
  height: 28px;
  // width: 80%;
  line-height: 28px;
  cursor: pointer;
  // position: relative;
  &:hover {
    color: #fe4d45;
    border: 1px solid #fe4d45;
  }
}
.btn1 {
  color: #fe4d45;
  background: #fff;
  border: 1px solid #fe4d45;
  border-radius: 4px;
  cursor: pointer;
}
.shop {
  height: 100%;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  background-color: #fff;
  .head {
    width: 100%;
    height: 54px;
    justify-content: space-between;
    padding: 0 20px 0 24px;
    border-bottom: 1px solid #f6f6f6;
    .txt {
      font-size: 16px;
      font-weight: 800;
      color: #000000;
      // margin-top: 7px;
    }
    p {
      color: #333;
      font-size: 14px;
    }
  }
  .shop-content {
    display: flex;
    box-sizing: border-box;
    padding: 0px 8px 0px 0px;
    width: 100%;
    height: 142px;
    > div {
      flex: 1;
    }
    .num {
      color: #252c38;
      font-size: 20px;
      @media screen and (max-width: 1366px) {
        font-size: 18px;
      }
      font-weight: 800;
      line-height: 21px;
      margin-top: 6px;
    }
    .my-info-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .version-icon {
        padding-left: 25px;
        // margin-top: 5px;
        .shop-name {
          width: 208px;
          font-size: 14px;
          position: absolute;
          color: #252c38;
          top: 156px;
          // font-weight: bold;
          line-height: 22px;
          padding-right: 5px;
        }
      }
    }
    .myInfo {
      display: flex;
      // justify-content: center;
      align-items: center;
      font-size: 12px;
      .header-img {
        padding: 0 25px 0 25px;
        img.header {
          width: 207px;
          height: 68px;
          overflow: hidden;
          border-radius: 4px;
          // border-radius: 54px;
          margin-top: -30px;
          margin-bottom: 8px;
        }
      }
      .shop-title {
        font-size: 12px;
        color: #666;
      }
      .shop-name {
        font-size: 14px;
        color: #252c38;
        font-weight: bold;
        line-height: 22px;
        padding-right: 5px;
      }
      .pop-btn {
        background: linear-gradient(90deg, #ff4e4c 0%, #ff783f 100%);
        color: #fff;
        height: 23px;
        border-radius: 23px;
        border: none;
        width: 80px;
        margin-top: 10px;
      }

      .tit {
        color: #252c38;
      }
      .number {
        color: #999;
      }
      .common_sms {
        flex: 1;
        flex-direction: column;
        justify-content: space-between;
      }
      .accurate {
        flex: 1;
        flex-direction: column;
      }
      .content {
        flex-direction: column;
        margin-bottom: 15px;
      }
      button {
        width: 70px;
        height: 26px;
      }
      .edition {
        width: 62px;
        height: 18px;
        color: #fff;
        text-align: center;
        // background:linear-gradient(134deg,rgba(118,111,255,1) 0%,rgba(69,61,225,1) 100%);
        background: url("../../assets/images/edition_bg.png") no-repeat 100%
          center;
      }
    }
    .details {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      box-sizing: border-box;
      padding-left: 13px;
      border-left: 1px solid #f3f3f3;
      color: #252c38;
      .top {
        display: flex;
        flex: 1;
        text-align: left;
        flex-direction: column;
        padding-top: 8px;
        // justify-content: space-between;
        // margin-bottom: 20px;
        // padding-bottom: 20px;
        .rightBtn {
          margin-top: 10px;
          .autograph {
            font-size: 20px;
            @media screen and (max-width: 1366px) {
              font-size: 18px;
            }
            font-family: DIN;
            font-weight: bold;
          }
          display: flex;
          justify-content: space-between;
        }
      }
      .left_content {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
      }
      .bottom {
        display: flex;
        flex: 1.2;
        align-items: flex-start;
        justify-content: space-between;
        border-top: 1px solid #f3f3f3;
        padding-top: 8px;
        .termofValidity {
          display: flex;
          flex-direction: column;
        }
        .rightBtn {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          position: relative;
        }
      }
      .txt {
        color: #666666;
        font-size: 12px;
        // margin-top: 7px;
      }

      .time {
        // font-family: PingFang SC;
        font-weight: 400;
        color: #7f85e9;
        font-size: 12px;
        // margin-top: 7px;
                @media screen and (max-width: 1365px) {
          left: -84px;
        }
        @media screen and (min-width: 1366px) and (max-width: 1539px) {
          left: -90px;
        }
        @media screen and (min-width: 1540px) and (max-width: 1600px) {
          left: -120px;
        }
        @media screen and (min-width: 1600px) and (max-width: 1700px) {
          left: -134px;
        }
        @media screen and (min-width: 1700px) {
          left: -178px;
        }
        
        top: 44px;
        position: absolute;
        width: 135px;
        bottom: -27px;
      }
      .recharge,
      .renew {
        width: 70px;
        height: 26px;
        line-height: 26px;
        // margin-left: 24px;
        border: none;
        outline: none;
        background-color: white;
        border-radius: 3px;
        cursor: pointer;
        text-align: center;
        margin-top: 4px;
        font-size: 13px;
                        @media screen and (max-width: 1365px) {
                 width: 60px;
        height: 24px;
                line-height: 22px;
        }
      }
      .recharge {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        border-radius: 3px;
        margin-top: -3px;
        background-color: #fff4f4;
        &:hover {
          color: #fe4d45;
          background-color: #ffe5e5;
        }
        &:active {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
      }
      .renew {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        border-radius: 3px;
        background-color: #fff4f4;
        &:hover {
          color: #fe4d45;
          background-color: #ffe5e5;
        }
        &:active {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
      }
    }
  }
  /**  不同分辨率适配  */
  @media screen and (max-width: 1540px) {
    .shop-content {
      .myInfo {
        .header-img {
          padding: 0 12px 0 12px;
          img.header {
            width: 160px;
            height: 53px;
          }
        }
        .shop-name {
          font-size: 14px;
          font-weight: 500;
        }
      }
      .my-info-box {
        .version-icon {
          padding-left: 12px;
          .shop-name {
            width: 162px;
            font-size: 14px;
            position: absolute;
            color: #252c38;
            top: 153px;
            // font-weight: bold;
            line-height: 16px;
            padding-right: 5px;
          }
        }
      }
      .details {
        padding-left: 8px;
      }
    }
  }
  @media screen and (min-width: 1540px) {
    .shop-content {
      .myInfo {
        .header-img {
          padding: 0 25px 0 25px;
          img.header {
            width: 160px;
            height: 53px;
          }
        }
        // .shop-name {
        //   font-size: 14px;
        //   font-weight: 500;
        // }
      }
      .my-info-box {
        .version-icon {
          padding-left: 25px;
          .shop-name {
            width: 208px;
            font-size: 14px;
            position: absolute;
            color: #252c38;
            top: 156px;
            // font-weight: 600;
            line-height: 22px;
            padding-right: 5px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            // white-space: pre;
          }
        }
      }
      .details {
        padding-left: 13px;
      }
    }
  }
  // @media screen and (max-width: 1540px) {
  //   .shop-content {
  //     padding: 16px 20px 16px 20px;
  //     .myInfo {
  //       margin-right: 15px;
  //     }
  //     .details {
  //       padding-left: 13px;
  //       .recharge,
  //       .renew {
  //         margin-left: 14px;
  //       }
  //     }
  //   }
  // }
}
</style>
